<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-pc`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M43 5a2 2 0 012 2v27a2 2 0 01-2 2H26v2.999L33 39a1 1 0 011 1v2a1 1 0 01-1 1l-7-.001V43h-4v-.001L15 43a1 1 0 01-1-1v-2a1 1 0 011-1l7-.001V36H5a2 2 0 01-2-2V7a2 2 0 012-2h38zm-2.001 23h-34L7 32h34l-.001-4zM41 9H7l-.001 15h34L41 9z"/></svg>
</template>
<script>

export default {
  name: 'IconPc',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
